import React, { useState } from 'react';
import axios from 'axios';
import '../Contact.css';
import BASE_URL from '../../config';

const ContactDe = () => {
  const [formData, setFormData] = useState({
    first_name: '', last_name: '', email: '', phone: '', subject: '', message: ''
  });
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      await axios.post(`${BASE_URL}/api/contact/`, {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      });
      setStatus({ type: 'success', text: 'Vielen Dank! Ihre Nachricht wurde gesendet. Wir melden uns innerhalb von 48 Stunden bei Ihnen.' });
      setFormData({ first_name: '', last_name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      const msg = err?.response?.data?.error || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.';
      setStatus({ type: 'error', text: msg });
    } finally {
      setSending(false);
    }
  };
  return (
    <div className="contact-page">
      <h1>Kontakt</h1>
      <p className="contact-page-sub">
        Wir freuen uns von Ihnen zu hören — Fragen, Bestellungen oder einfach nur Hallo sagen.
      </p>

      <div className="contact-grid">
        {/* Left column — Contact info */}
        <div>
          <h2 className="contact-section-title">Kontaktieren Sie uns</h2>
          <div className="contact-info-card">
            <div className="contact-info-item">
              <div className="contact-info-icon">🏢</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Unternehmen</div>
                <div className="contact-info-value">Vegbox GmbH</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">📍</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Adresse</div>
                <div className="contact-info-value">
                  Dietlikonstrasse 29<br />
                  8600 Dübendorf, Schweiz
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">📞</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Telefon</div>
                <div className="contact-info-value">
                  <a href="tel:+41782224236">+41 78 222 42 36</a>
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">✉️</div>
              <div className="contact-info-content">
                <div className="contact-info-label">E-Mail</div>
                <div className="contact-info-value">
                  <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">🕐</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Öffnungszeiten</div>
                <div className="contact-info-value">
                  Mo – Fr: 9:00 – 18:00 Uhr<br />
                  Sa – So: 10:00 – 16:00 Uhr
                </div>
              </div>
            </div>
          </div>

          <a
            href="https://www.instagram.com/vegbox.ch/?hl=en"
            target="_blank"
            rel="noreferrer"
            className="contact-social"
          >
            <span className="contact-social-icon">📷</span>
            Folgen Sie uns auf Instagram
          </a>
        </div>

        {/* Right column — Map */}
        <div>
          <h2 className="contact-section-title">Unser Standort</h2>
          <div className="contact-map-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2700.544!2d8.618!3d47.398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479aa0e5e7f5e7e7%3A0x1234567890abcdef!2sDietlikonstrasse%2029%2C%208600%20D%C3%BCbendorf%2C%20Switzerland!5e0!3m2!1sde!2sus!4v1234567890"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Vegbox Standort"
            ></iframe>
          </div>
          <p className="contact-map-note">
            Wir befinden uns im Herzen von Dübendorf und sind mit ÖV und Auto gut erreichbar.
          </p>
        </div>
      </div>

      {/* Contact form */}
      <div className="contact-form-section">
        <h2>Schreiben Sie uns</h2>
        <p className="contact-form-sub">Füllen Sie das Formular aus und wir melden uns in Kürze bei Ihnen.</p>

        <div className="contact-form-card">
          <form onSubmit={handleSubmit}>
            {status && (
              <div className={`contact-form-status ${status.type}`}>
                {status.type === 'success' ? '✅ ' : '⚠️ '}{status.text}
              </div>
            )}
            <div className="contact-form-row">
              <div className="contact-form-field">
                <label htmlFor="first_name">Vorname</label>
                <input type="text" id="first_name" placeholder="Max" required value={formData.first_name} onChange={handleChange} />
              </div>
              <div className="contact-form-field">
                <label htmlFor="last_name">Nachname</label>
                <input type="text" id="last_name" placeholder="Mustermann" required value={formData.last_name} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field">
                <label htmlFor="email">E-Mail-Adresse</label>
                <input type="email" id="email" placeholder="max@beispiel.ch" required value={formData.email} onChange={handleChange} />
              </div>
              <div className="contact-form-field">
                <label htmlFor="phone">Telefonnummer</label>
                <input type="tel" id="phone" placeholder="+41 ..." value={formData.phone} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field full">
                <label htmlFor="subject">Betreff</label>
                <input type="text" id="subject" placeholder="Wie können wir helfen?" required value={formData.subject} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field full">
                <label htmlFor="message">Nachricht</label>
                <textarea id="message" placeholder="Schreiben Sie Ihre Nachricht hier..." required value={formData.message} onChange={handleChange}></textarea>
              </div>
            </div>
            <button type="submit" className="contact-submit-btn" disabled={sending}>
              {sending ? 'Wird gesendet…' : 'Nachricht senden'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactDe;